import http from '@root/utils/axios/admin';

let state = {
    GameActivitiesList: [],
    GameActivity: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchGameActivitiesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('user/game-activities', { params: filter }).then((response) => {
                commit('setGameActivitiesList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteGameActivity({ commit }, id) {
        return http.delete('user/game-activities/' + id);
    },

    fetchGameActivity({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('user/game-activities/' + id).then((response) => {
                commit('setGameActivity', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateGameActivity({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/game-activities', data).then((response) => {
                commit('setGameActivity', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setGameActivityError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateGameActivity({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/game-activities/' + data.get('id'), data).then((response) => {
                commit('setGameActivity', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setGameActivityError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setGameActivitiesList(state, data) {
        state.GameActivitiesList = data;
    },
    setGameActivity(state, data) {
        state.GameActivity.data = data;
    },
    setGameActivityError(state, error) {

        state.GameActivity.error = error.errors;
    },
    cleanGameActivityError(state, error) {
        state.GameActivity.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}